module.exports = __webpack_public_path__ + "img/arrow-right.24d8c5b2.svg";